import { Link } from 'react-router-dom';
import { comics, featuredComicSlugs } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

const featuredComics = featuredComicSlugs
  .map((slug) => comics.find((c) => c.slug === slug))
  .filter(Boolean) as NonNullable<ReturnType<typeof comics.find>>[];

export default function FeaturedComics() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              热门推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              本周最受欢迎的漫画作品
            </p>
          </div>
          <Link
            to="/category/series"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}